import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import { date_format, datetime_format } from "../Common/DateFormat";
import { API_URL, BACKEND_URL } from "../constants.js";
import {
  printReportUrl,
  printPatientDetailUrl,
  printNewReportUrl,
  patientEditUrl,
  patientDuplicateUrl,
  getPatientSampleId,
} from "../Common/patientIdentifier";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import EditIcon from "@material-ui/icons/Edit";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import ArchiveIcon from "@material-ui/icons/Archive";
import FileCopyIcon from "@material-ui/icons/FileCopy";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";

export function PatientList(props) {
  const { t } = useTranslation();
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState(null);
  const [show, setShow] = useState(false);
  const [action, setAction] = useState("patient");
  const history = useHistory();

  const setCurrentPatient = (patient, action) => {
    setPatient(patient);
    setAction(action);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const deletePatient = () => {
    axios
      .post(API_URL + "patient/delete", {
        id: patient,
        action: action,
      })
      .then((response) => {
        if (response.data.status) {
          history.go(0);
          setShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  useEffect(() => {
    axios
      .get(API_URL + "patient")
      .then((response) => {
        if (response.data.status) {
          setPatients(response.data.data.patients);

          $("#patient_table").DataTable();
        } else {
          alertify.error(response.data.message);
          return null;
        }
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          //props.logout();
        }
      });
  }, []);

  return (
    <>
      <style>{`.patient-actions .btn:hover svg { color: currentColor !important; }`}</style>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title={t("Patients List")}>
              <CardHeaderToolbar>
                <Link
                  to="/patient/create"
                  className="btn btn-primary btn-sm mx-3"
                >
                  {t("Create Patient")}
                </Link>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody style={{ overflow: "auto" }}>
              <table
                id="patient_table"
                className="stratprop_datatable table table-striped table-bordered"
              >
                <thead>
                  <tr key={"thead"}>
                    <th>{t("SN.")}</th>
                    <th>{t("Actions")}</th>
                    <th>{t("Sample ID")}</th>
                    <th>{t("First Name")}</th>
                    <th>{t("Last Name")}</th>
                    <th>{t("Passport")}</th>
                    <th>{t("Collection At")}</th>
                    {/*<th>{t("Collection Time")}</th>*/}
                    <th>{t("Gender")}</th>
                    <th>{t("D.O.B")}</th>
                    {/*<th>{t("Phone")}</th>*/}
                    <th>{t("Email")}</th>
                    <th>{t("Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length > 0 ? (
                    patients.map((patient, index) => (
                      <tr key={index + 1} className={patient.sent_activation_msg == 1 ? 'sent-activation-msg' : ''}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex flex-wrap patient-actions" style={{ width: "100px" }}>
                            <Link to={patientEditUrl(patient.id)} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Edit Patient">
                              <EditIcon color="inherit" />
                            </Link>
                            <a href={printPatientDetailUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="View Patient Detail">
                              <BeachAccessIcon color="inherit" />
                            </a>
                            <a href={printReportUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Print Report">
                              <DescriptionIcon color="inherit" />
                            </a>
                            <a onClick={() => setCurrentPatient(patient.id, "patient")} className="btn btn-outline-danger m-1" style={{ width: "42px" }} title="Delete Patient Record">
                              <DeleteForeverIcon color="inherit" />
                            </a>
                            <a onClick={() => setCurrentPatient(patient.id, "report")} className="btn btn-outline-danger m-1" style={{ width: "42px" }} title="Delete Patient Report">
                              <HighlightOffIcon color="inherit" />
                            </a>
                            <Link to={patientDuplicateUrl(getPatientSampleId(patient))} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Duplicate Patient">
                              <FileCopyIcon color="inherit" />
                            </Link>
                          </div>
                        </td>
                        <td>{patient.sample_id}</td>
                        <td>{patient.first_name}</td>
                        <td>{patient.last_name}</td>
                        <td>{patient.passport_number}</td>
                        {/*<td>{(patient.registered_at) ? datetime_format(patient.registered_at) : ""}</td>*/}
                        <td>
                          {patient.collection_datetime
                            ? datetime_format(patient.collection_datetime)
                            : ""}
                        </td>
                        <td>{patient.gender}</td>
                        <td>{patient.dob ? date_format(patient.dob) : ""}</td>
                        {/*<td>{patient.phone_no}</td>*/}
                        <td>{patient.email}</td>
                        <td>{patient.report_status.name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr key={"nopatient"}>
                      <td colSpan={13}>No Patient</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Patient / Report")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close")}
          </Button>
          <Button variant="primary" onClick={deletePatient}>
            {t("Confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
